import { useCartStore } from "../store/useCartStore";
import { CartItemsList, EmptyCartState } from "../components/Cart";
import { toast } from "sonner";
import { OrderSummary } from "../components/OrderSummary";

export default function BillingContainer() {
  const { items, removeItem, getItemCount, getTotalPrice } = useCartStore();
  const itemCount = getItemCount();
  const totalPrice = getTotalPrice();

  const handleRemoveItem = (itemId: string) => {
    removeItem(itemId);
    toast.info("Item Removed", {
      description: "Item has been removed from your cart.",
      position: "top-center",
    });
  };

  return (
    <div className="mx-auto flex h-screen min-w-[1040px] flex-row gap-5 p-3 pt-5">
      <div className="flex h-full w-full max-w-[428px] flex-col rounded-[12px] bg-white">
        {/* Header */}
        <div className="flex-shrink-0 px-5 py-3">
          <h1 className="text-lg font-extrabold -tracking-wide text-neutral-800">
            Cart
          </h1>
        </div>

        {/* Cart Items List */}
        <div
          className="scrollbar-thin flex-1 overflow-y-auto px-5"
          style={{ scrollbarGutter: "stable" }}
        >
          {itemCount === 0 ? (
            <div className="flex h-full items-center justify-center py-8">
              <EmptyCartState />
            </div>
          ) : (
            <CartItemsList items={items} onRemoveItem={handleRemoveItem} />
          )}
        </div>
      </div>
      <div className="mx-auto flex h-full w-full max-w-[592px] flex-col rounded-[12px] bg-white">
        {/* Cart Items List */}
        <div
          className="scrollbar-thin flex-1 overflow-y-auto px-5"
          style={{ scrollbarGutter: "stable" }}
        >
          <OrderSummary totalPrice={totalPrice} totalItems={itemCount} />
        </div>
      </div>
    </div>
  );
}
